import script from "./WEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./WEditor.vue?vue&type=script&setup=true&lang=js"

import "./WEditor.vue?vue&type=style&index=0&id=4f41a9f5&lang=css"

const __exports__ = script;

export default __exports__